import CampaignModel from "./CampaignModel";
import ContentModel from "./ContentModel";
import TagsModel from "./TagsModel";

export default class ContextModel {
  public content?: ContentModel = null;
  public tags: TagsModel[] = [];
  public campaign?: CampaignModel = null;
}
